import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Calendar } from 'lucide-react';
import { format, addMonths, subMonths, addWeeks, subWeeks, addDays, subDays, startOfWeek, endOfWeek } from 'date-fns';

const Header = ({ currentDate, onDateChange, viewMode }) => {
  const [showDatePicker, setShowDatePicker] = useState(false);

  const handlePrevious = () => {
    switch (viewMode) {
      case 'week':
        onDateChange(subWeeks(currentDate, 1));
        break;
      case 'day':
        onDateChange(subDays(currentDate, 1));
        break;
      default:
        onDateChange(subMonths(currentDate, 1));
    }
  };

  const handleNext = () => {
    switch (viewMode) {
      case 'week':
        onDateChange(addWeeks(currentDate, 1));
        break;
      case 'day':
        onDateChange(addDays(currentDate, 1));
        break;
      default:
        onDateChange(addMonths(currentDate, 1));
    }
  };

  const handleToday = () => {
    onDateChange(new Date());
  };

  const handleDatePickerChange = (event) => {
    const selectedDate = new Date(event.target.value);
    onDateChange(selectedDate);
    setShowDatePicker(false);
  };

  const getDateRangeText = () => {
    switch (viewMode) {
      case 'week':
        const weekStart = startOfWeek(currentDate, { weekStartsOn: 1 });
        const weekEnd = endOfWeek(currentDate, { weekStartsOn: 1 });
        return `${format(weekStart, 'MMM d')} - ${format(weekEnd, 'MMM d, yyyy')}`;
      case 'day':
        return format(currentDate, 'EEEE, MMMM d, yyyy');
      default:
        return format(currentDate, 'MMMM yyyy');
    }
  };

  return (
    <header className="header">
      <div className="header-content">
        <h1 className="app-title">planSMART</h1>
        
        <nav className="navigation">
          <button 
            className="nav-button" 
            onClick={handlePrevious}
            aria-label={`Previous ${viewMode}`}
          >
            <ChevronLeft size={20} />
          </button>
          
          <div className="date-display-container">
            <div 
              className="current-date"
              onClick={() => setShowDatePicker(!showDatePicker)}
            >
              {getDateRangeText()}
              <Calendar size={16} className="date-picker-icon" />
            </div>
            
            {showDatePicker && (
              <div className="date-picker-dropdown">
                <input
                  type="date"
                  value={format(currentDate, 'yyyy-MM-dd')}
                  onChange={handleDatePickerChange}
                  className="date-picker-input"
                  autoFocus
                />
                <div className="quick-actions">
                  <button 
                    className="quick-action-btn"
                    onClick={() => {
                      onDateChange(new Date());
                      setShowDatePicker(false);
                    }}
                  >
                    Today
                  </button>
                  <button 
                    className="quick-action-btn"
                    onClick={() => {
                      onDateChange(addDays(new Date(), 1));
                      setShowDatePicker(false);
                    }}
                  >
                    Tomorrow
                  </button>
                </div>
              </div>
            )}
          </div>
          
          <button 
            className="nav-button" 
            onClick={handleNext}
            aria-label={`Next ${viewMode}`}
          >
            <ChevronRight size={20} />
          </button>
          
          <button 
            className="nav-button today-button" 
            onClick={handleToday}
            aria-label="Go to today"
          >
            Today
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;


